<template>
  <div>
    <Titles v-if="showGraphics" :datosGrafica="datosGrafica" />
    <div class="container">
      <h2>Comparador de Recursos Humanos</h2>
      <div class="head-comparator container">
        <div style="width: 33%;">
          <b-button class="btn-return" :to="{ name: 'comparate' }">
            <i class="bx bx-left-arrow-alt"></i> Regresar
          </b-button>
        </div>

        <div class="select-year" style="width: 33%;">
          <p class="text-sy">Seleccione un Año:</p>
          <b-form-select
            class="select"
            v-model="selectedYear"
            :options="options"
          ></b-form-select>
        </div>

        <div style="width: 33%;"></div>
      </div>
      <div class="loading" v-show="loading">
        <Loading />
      </div>
      <div v-if="showGraphics">
        <ComparatorGraphics
          style="padding: 1.5rem;"
          v-for="(item, index) in datosGrafica"
          :key="index"
          :titles="item.titles"
          :content="item.data"
          :title="item.mainTitle"
          :selectedYear="selectedYear"
          :idGraphic="`graphic-` + index"
        />
      </div>
      <AlertError v-if="!loading && !showGraphics" />
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import ComparatorGraphics from "./ComparatorGraphic.vue";
import Loading from "../../../components/tools/Loading.vue";
import AlertError from "../../../components/error/AlertError.vue";
import Titles from "../../comparateFinanciero/components/Titles.vue";
export default {
  components: {
    ComparatorGraphics,
    Loading,
    AlertError,
    Titles,
  },
  data() {
    return {
      options: [{ value: null, text: "- Año -" }],
      selectedYear: "2020",
      titulosGrafica: null,
      datosGrafica: [],
      showGraphics: false,
      loading: true,
    };
  },
  computed: {
    ...mapGetters([
      "rrhhComparator",
      "comparatorService_1",
      "comparatorService_2",
    ]),
  },
  methods: {
    getDataComp: async function() {
      try {
        const {
          genero,
          edad,
          tipo_contrato,
          estamento,
          permanencia,
        } = this.rrhhComparator;
        const baseUrl = `${process.env.VUE_APP_RUTA_API}/comparador/?servicio_1=${this.comparatorService_1}&servicio_2=${this.comparatorService_2}&tipo_comparador=recursos_humanos`;

        if (
          this.options.length === 1 &&
          this.comparatorService_1 &&
          this.comparatorService_2
        ) {
          const res = await axios.get(baseUrl + "&edad=");
          this.setYearList(res.data);
        }

        if (genero) {
          const genFiltro = await axios.get(`${baseUrl}&genero=${genero}`);
          this.datosGrafica.push(
            this.buildData(genFiltro.data, "Comparación por Género año ")
          );
        }
        if (edad) {
          const edadFiltro = await axios.get(`${baseUrl}&edad=${edad}`);
          this.datosGrafica.push(
            this.buildData(edadFiltro.data, "Resultados por Edad año")
          );
        }
        if (tipo_contrato) {
          const tcFiltro = await axios.get(
            `${baseUrl}&tipo_contrato=${tipo_contrato}`
          );
          this.datosGrafica.push(
            this.buildData(
              tcFiltro.data,
              "Comparación por Tipo de Contrato año"
            )
          );
        }
        if (estamento) {
          const estFiltro = await axios.get(
            `${baseUrl}&estamento=${estamento}`
          );
          this.datosGrafica.push(
            this.buildData(estFiltro.data, "Comparación por Estamento año ")
          );
        }
        if (permanencia) {
          const permFiltro = await axios.get(
            `${baseUrl}&permanencia=${permanencia}`
          );
          this.datosGrafica.push(
            this.buildData(
              permFiltro.data,
              "Relación por Tiempo de Permanencia año"
            )
          );
        }

        this.showGraphics = this.datosGrafica.length > 0;
        // this.highestValue();
        this.loading = false;
      } catch (error) {
        this.showGraphics = false;
        this.loading = false;
        console.log(error);
      }
    },
    setYearList: function(list) {
      this.options = Object.keys(list[Object.keys(list)[0]].resultados).map(
        (y) => ({
          value: y,
          text: y,
        })
      );

      this.options.unshift({ value: null, text: "- Año -" });
    },
    buildData: function(data, mainTitle) {
      const labels = Object.keys(data);
      const gdata = [];
      let toAppend;
      labels.forEach((e) => {
        toAppend = data[e].resultados[this.selectedYear];
        gdata.push(
          toAppend
            ? toAppend.map((f) => f.filtros[Object.keys(f.filtros)[0]])
            : ""
        );
        gdata.push(toAppend ? toAppend.map((f) => f.total) : 0);
      });
      return {
        mainTitle: mainTitle,
        titles: labels,
        data: gdata.slice(0, 2).concat([gdata[3]]),
      };
    },
  },
  watch: {
    selectedYear: function() {
      this.datosGrafica = [];
      this.loading = true;
      this.getDataComp();
    },
  },
  mounted() {
    this.getDataComp();
  },
  destroyed() {
    this.$store.commit("resetRRHHComparator");
  },
};
</script>

<style scoped>
h2 {
  margin-top: 15px;
  text-align: center;
}
.select {
  border: 1px solid rgb(228, 228, 228);
  width: 100px;
  font-size: 16px;
  color: #222222;
  border-radius: 5px;
}
.text-sy {
  margin: 0.5rem;
}
.select-year {
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
}

.head-comparator {
  display: flex;
  justify-content: center;
  align-items: center;
}

.btn-return {
  text-align: center;
  width: 120px;
  color: #696969;
  background: #e0e0e0;
  border: none;
  border-radius: 40px;
  font-size: 16px;
  left: 94px;
}

.btn-return:hover {
  color: #052333;
  background: #24c6ab;
  border: none;
}
.loading {
  height: 30vh;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
